import {
  Component,
  DestroyRef,
  OnInit,
  computed,
  inject,
  signal,
} from '@angular/core';
import {
  FormBuilder,
  // FormGroup,
  // FormsModule,
  ReactiveFormsModule,
  // Validators,
} from '@angular/forms';
// import { finalize, merge, of } from 'rxjs';
// import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SkeletonModule } from 'primeng/skeleton';

// import { ProductIngredientActionsType, ProductTypsFacade } from '@ls-commons/productIngredients/store';
import { ModalService } from '@ls-commons/utils/modals';

// import { ProductIngredientService } from '../product-type.service';
import { HttpClient } from '@angular/common/http';
import { CheckboxModule } from 'primeng/checkbox';
import { Product, ProductIngredient } from '../cart.model';
import { CartService } from '../cart.service';
import { QuantityCounterComponent } from '../quantity-counter/quantity-counter.component';
import { NgFor, NgIf } from '@angular/common';
import { DividerModule } from 'primeng/divider';
// import { ProductIngredient } from '../product-type.model';
// import { InputSwitchMoleculeComponent } from '../../../manager/components/input-switch-molecule/input-switch-molecule.component';
import _ from 'lodash';
import { IngredientNamePipe } from 'src/app/pipes/ingredient-name/ingredient-name.pipe';
import {
  FormFieldMoleculeComponent,
  LabelAtomComponent,
} from '@ls-commons/components';

@Component({
  selector: 'app-product-ingredients',
  standalone: true,
  imports: [
    FormFieldMoleculeComponent,
    ButtonModule,
    SelectButtonModule,
    LabelAtomComponent,
    ReactiveFormsModule,
    SkeletonModule,
    CheckboxModule,
    FormFieldMoleculeComponent,
    LabelAtomComponent,
    QuantityCounterComponent,
    NgFor,
    NgIf,
    DividerModule,
    IngredientNamePipe,
    // InputSwitchMoleculeComponent,
  ],
  templateUrl: './product-ingredients.component.html',
  styleUrl: './product-ingredients.component.scss',
})
export class ProductIngredientsComponent implements OnInit {
  // productIngredientForm!: FormGroup;
  modalService = inject(ModalService);
  destroyRef = inject(DestroyRef);
  // productIngredientService = inject(ProductIngredientService);
  cartService = inject(CartService);
  http = inject(HttpClient);

  // product_ingredient_id!: number;
  saving = false;
  product: Product | null = null;
  updatedQuantity: number = 0;
  items: ProductIngredient[];

  private _isLoading = signal<boolean>(true);
  public isLoading = computed(() => this._isLoading());

  // isNewProductIngredient = this.config.data.product_ingredient_id === null;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    readonly fb: FormBuilder
  ) {
    const { product } = this.config.data;
    this.product = product;
    this.items = _.cloneDeep(this.cartService.ingredientsList);
  }

  ngOnInit(): void {
    // this.product_ingredient_id != null;
    // ? this.productIngredientService
    //     .getProductIngredient(this.product_ingredient_id)
    //     .pipe(finalize(() => this._isLoading.set(false)))
    //     .subscribe((response: ProductIngredient) => {
    //       this.productIngredient = {
    //         ...response,
    //         estado: response.estado?.toString(),
    //       };
    //       console.log(response);

    //       this.productIngredientForm.patchValue(this.productIngredient);
    //     })
    // : of(this._isLoading.set(false));

    // console.log('Producto seleccionado:', this.product?.ingredients);
    this.product?.ingredients?.forEach((ingredient) => {
      this.items.find((productIngredient, index) => {
        if (productIngredient.productIngredientId === ingredient) {
          this.items[index].initialQuantity = 1;
        }
      });
    });
  }

  closeDialog() {
    this.ref.close(false);
  }

  addToCart() {
    // const productIngredient = this.productIngredientForm.getRawValue();
    // const observable$ = this.product_ingredient_id;
    // ? this.cartService.modifyProductIngredient(productIngredient)
    // : this.cartService.addProductIngredient(productIngredient);
    // this.productIngredientForm.markAllAsTouched();
    // if (this.productIngredientForm.valid) {
    //   observable$.subscribe({
    //     next: () => {
    //       this.modalService.showSuccessMessage(
    //         `ProductIngrediente ${!this.product_ingredient_id ? 'añadido' : 'modificado'}`
    //       );
    //       this.ref.close(true);
    //     },
    //   });
    // }
    this.cartService.addProduct(this.product!, 1);
    this.modalService.showSuccessMessage(`Producto añadido`);
    this.ref.close(true);
  }

  changeQuantity(productId: number, value: number | null) {
    if (value !== null) {
      // this.updatedQuantity = value;
      // this.cartService.changeProductQuantity(productId, value);
    }
  }

  calculateExtraAmount(ingredient: ProductIngredient, value: number) {
    // console.log(ingredient);
    const newValue = value - ingredient.initialQuantity!;
    ingredient.totalPrice = newValue > 0 ? ingredient.price * newValue : 0;
  }

  calculatePrice() {
    let extraPrice = 0;
    this.items.forEach((item) => {
      extraPrice += item.totalPrice;
    });
    this.product!.extraPrice = extraPrice;
  }

  updateFinalIngredients(productIngredientId: number, value: number) {
    const final = this.product!.finalIngredients.filter(
      (ingredient) => ingredient !== productIngredientId
    );

    this.product!.finalIngredients = final;

    for (let index = 0; index < value; index++) {
      this.product?.finalIngredients.push(productIngredientId);
      console.log(index);
    }

    this.updateFinalIngredientsName();
  }

  updateFinalIngredientsName() {
    const namePipe = new IngredientNamePipe(this.cartService);
    this.product!.finalIngredientsName = [];

    this.product?.finalIngredients.forEach((ingredient) => {
      this.product?.finalIngredientsName.push(namePipe.transform(ingredient));
    });
  }
}
